import { render } from "./roomcash_scale_container.vue?vue&type=template&id=8c220ad0"
import script from "./roomcash_scale_container.vue?vue&type=script&lang=js"
export * from "./roomcash_scale_container.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__